var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { value: _vm.showDialog, width: "500px" },
      on: {
        input: function($event) {
          return _vm.close()
        }
      }
    },
    [
      _c(
        "v-card",
        { staticClass: "image-card" },
        [
          _vm.imageData.value
            ? _c(
                "div",
                {
                  staticClass: "icon-layout",
                  staticStyle: { padding: "10px 20px 10px" }
                },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "photo-form-button",
                      attrs: { icon: "", small: "", color: "accent" },
                      on: { click: _vm.rotateRight }
                    },
                    [
                      _c("v-icon", { attrs: { size: "22" } }, [
                        _vm._v("rotate_right")
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "photo-form-button",
                      attrs: { icon: "", small: "", color: "accent" }
                    },
                    [
                      _vm.imageData.value
                        ? _c(
                            "a",
                            {
                              attrs: {
                                download: _vm.imageData.label,
                                href: _vm.imageData.value
                              }
                            },
                            [
                              _c(
                                "v-icon",
                                { attrs: { size: "20", color: "accent" } },
                                [_vm._v("file_download")]
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { style: "transform: rotate(" + _vm.rotation + "deg);" }, [
            _vm.imageData.value
              ? _c("img", {
                  attrs: {
                    src: _vm.imageData.value,
                    alt: _vm.imageData.label,
                    contain: "",
                    "max-height": "550px"
                  }
                })
              : _vm._e()
          ]),
          _vm._v(" "),
          _c(
            "v-card-title",
            { staticClass: "download" },
            [
              _c("h4", [_vm._v(_vm._s(_vm.imageData.label))]),
              _vm._v(" "),
              _vm.taskDecisionButtons
                ? _c("task-decision-buttons", {
                    attrs: {
                      uuid: _vm.imageData.uuid,
                      taskContents: _vm.taskContents
                    },
                    on: {
                      approve: function($event) {
                        return _vm.$emit("updateTaskContents", {
                          decision: "approve",
                          uuid: _vm.imageData.uuid
                        })
                      },
                      reject: function($event) {
                        return _vm.$emit("updateTaskContents", {
                          decision: "reject",
                          uuid: _vm.imageData.uuid
                        })
                      }
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-854b6814", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-854b6814","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FieldManagement/FieldWork/Data/TaskType/PhotoView.vue
// module id = null
// module chunks = 